<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
<div class="container">
	<h4 class="page__main-title margin-top-60">Portals</h4>
	<div class="container-small text-center margin-top-60" v-if="!demoMode && loadingData">
		<p class="loading-text">Loading data<span>.</span><span>.</span><span>.</span></p>
	</div>

	<div class="container-small" v-if="!demoMode && !loadingData">
    <transition appear appear-class="slide-fade-enter" appear-active-class="slide-fade-enter-active">

		<div class="mdc-card portal-settings__portal" :class="{'portal-settings__portal--active': rmActive}">
			<div class="portal-settings__portal-logo">
				<img src="/static/img/rightmove-logo.png">
			</div>
			<div class="mdc-card__supporting-text portal-settings__content">
				<p v-if="rmActive && rmLive">Your feed is active</p>
				<p v-if="rmActive && !rmLive">Waiting for Rightmove confirmation.</p>
				<button class="mdc-button mdc-button--stroked portal-settings__btn" v-on:click="$router.push('/settings/portals/rightmove')" v-if="!rmActive">Activate</button>
				<button class="mdc-button mdc-button--stroked portal-settings__btn--deactivate" v-on:click="disableRM" v-if="rmActive">Deactivate</button>
			</div>
		</div>
		</transition>

    <transition appear appear-class="slide-fade-enter" appear-active-class="slide-fade-enter-active">

		<div class="mdc-card portal-settings__portal" :class="{'portal-settings__portal--active': otmActive}">
			<div class="portal-settings__portal-logo">
				<img src="/static/img/onthemarket-logo.png">
			</div>
			<div class="mdc-card__supporting-text portal-settings__content">
				<p v-if="otmActive && otmLive">Your feed is active</p>
				<p v-if="otmActive && !otmLive">Waiting for OnTheMarket confirmation.</p>
				<button class="mdc-button mdc-button--stroked portal-settings__btn" v-on:click="$router.push('/settings/portals/onthemarket')" v-if="!otmActive">Activate</button>
				<button class="mdc-button mdc-button--stroked portal-settings__btn--deactivate" v-on:click="disableOTM" v-if="otmActive">Deactivate</button>
			</div>
		</div>
		</transition>
		<transition appear appear-class="slide-fade-enter" appear-active-class="slide-fade-enter-active">

		<div class="mdc-card portal-settings__portal" :class="{'portal-settings__portal--active': zooplaActive}">
			<div class="portal-settings__portal-logo">
				<img src="/static/img/zoopla-logo.png">
			</div>
			<div class="mdc-card__supporting-text portal-settings__content">
				<p v-if="zooplaActive && zooplaLive">Your feed is active</p>
				<p v-if="zooplaActive && !zooplaLive">Waiting for Zoopla confirmation.</p>
				<button class="mdc-button mdc-button--stroked portal-settings__btn" v-on:click="$router.push('/settings/portals/zoopla')" v-if="!zooplaActive">Activate</button>
				<button class="mdc-button mdc-button--stroked portal-settings__btn--deactivate" v-on:click="disableZoopla" v-if="zooplaActive">Deactivate</button>
			</div>
		</div>
		</transition>
		<transition appear appear-class="slide-fade-enter" appear-active-class="slide-fade-enter-active">

		<!-- Website -->
		<div class="mdc-card portal-settings__portal" :class="{'portal-settings__portal--active': websiteActive}">
			<div class="portal-settings__portal-logo">
				Website upload
			</div>
			<div class="mdc-card__supporting-text portal-settings__content">
				<p v-if="websiteActive">Your website upload is active</p>
				<button class="mdc-button mdc-button--stroked portal-settings__btn" v-on:click="$router.push('/settings/portals/website/' + (websitePortal.hasOwnProperty('portalId') ? websitePortal.portalId : ''))">Edit</button>
			</div>
		</div>
		</transition>
		<transition appear appear-class="slide-fade-enter" appear-active-class="slide-fade-enter-active">
		<!-- Custom Portals -->
		<div v-for="portal in customPortals" v-if="!portal.website" class="mdc-card portal-settings__portal" :class="{'portal-settings__portal--active': portal.active}">
			<div class="portal-settings__portal-logo">
				{{portal.portal_name}}
			</div>
			<div class="mdc-card__supporting-text portal-settings__content">
				<p v-if="portal.active">Your upload is active</p>
				<button class="mdc-button mdc-button--stroked portal-settings__btn" v-on:click="$router.push('/settings/portals/custom/' + portal.portalId)">Edit</button>
			</div>
		</div>
		</transition>

		<transition appear appear-class="slide-fade-enter" appear-active-class="slide-fade-enter-active">
		<div class="portal-settings__portal btn btn--bordered">
			<div class="portal-settings__portal-logo portal-settings__add-portal">
				<a href="#" class="" @click.prevent="$router.push('/settings/portals/custom')"><i class="ico-plus_math"></i> Add another upload</a>
			</div>
		</div>
		</transition>

		<!-- Back button -->
		<a href="#" class="black-link portal-page__btn portal-page__btn-back" @click.prevent="$router.push('/settings')">&lt; back</a>
	</div>
	<div class="container-small portal-settings__error" v-if="demoMode">
		{{demoMode ? 'Sorry, uploading to portals is not available on demo mode!': 'Sorry, uploading to portals is not available at the moment!'}}

		<!-- Back button -->
		<a href="#" class="black-link portal-page__btn portal-page__btn-back" @click.prevent="$router.push('/settings')">&lt; back</a>
	</div>
</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';

export default {
	data: function() {
		return {
			loadingData: true,
      otmActive: false,
			rmActive: false,
			zooplaActive: false,
			rmLive: false,
			zooplaLive: false,
      otmLive: false,
			rmBranches: {},
			zooplaBranches: {},
      otmBranches: {},
			websiteActive: false,
			websitePortal: {},
			customPortals: []
		}
	},
	computed: {
		demoMode: function() {
 		  return this.$store.getters.demoMode;
 	  }
	},
	created: async function() {
		let portals, portalsCustom;

		try {
			[portals, portalsCustom] = await Promise.all([
				api({endpoint: this.config.services.portals, method: 'GET'}),
				api({endpoint: this.config.services.portalsCustom, method: 'GET'})
			]);

			portals.map((portal) => {
				if(portal.portalId === 'rm') {
					this.rmActive = portal.active;
					this.rmLive = portal.live;
					this.rmBranches = portal.branches;
				}
        if(portal.portalId === 'zoopla') {
					this.zooplaActive = portal.active;
					this.zooplaLive = portal.live;
					this.zooplaBranches = portal.branches;
				}
        if(portal.portalId === 'otm') {
					this.otmActive = portal.active;
					this.otmLive = portal.live;
					this.otmBranches = portal.branches;
				}
			});

			this.customPortals = portalsCustom;
			portalsCustom.map((portal) => {
				if(portal.website) {
					this.websiteActive = portal.active;
					this.websitePortal = portal;
				}
			});
		} catch(err) {
			throw {
				type: 'get-all-portals',
				error: err
			}
		}
		this.loadingData = false;
	},
	methods: {
		disableRM: async function() {
			var postData = {
				active: false,
				branchIdLettings: this.rmBranches.branchIdLettings,
				branchIdSales: this.rmBranches.branchIdSales
			};

			var result = await api({endpoint: this.config.services.portals, path: '/rm', method: 'PUT', body: postData});

			this.rmActive = false;
		},
		disableZoopla: async function() {
			var postData = {
				active: false,
				branchIdLettings: this.zooplaBranches.branchIdLettings,
				branchIdSales: this.zooplaBranches.branchIdSales
			};

			var result = await api({endpoint: this.config.services.portals, path: '/zoopla', method: 'PUT', body: postData});

			this.zooplaActive = false;
		},
		disableOTM: async function() {
			var postData = {
				active: false,
				branchIdLettings: this.otmBranches.branchIdLettings,
				branchIdSales: this.otmBranches.branchIdSales
			};

			var result = await api({endpoint: this.config.services.portals, path: '/otm', method: 'PUT', body: postData});

			this.otmActive = false;
		}
	}
}


</script>



// WEBPACK FOOTER //
// src/pages/Settings-Portals.vue